import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from "@angular/router";
import {Observable} from "rxjs";
import * as fromStore from "../store";
import {Store} from "@ngrx/store";
import {filter, first, switchMap} from "rxjs/operators";

@Injectable()
export class UserLocalStorageResolver implements Resolve<any|null> {

  constructor(
    private _store: Store<fromStore.DbStoreState>
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any>|Promise<any>|any {
    return new Promise((resolve: Function, reject: Function): void => {
      this._store.select(fromStore.getUserLoaded)
        .pipe(
          filter((loaded: boolean) => loaded),
          switchMap(() => this._store.select(fromStore.getUserLocalStorage)),
          first()
        )
        .subscribe((userLocalStorage: any) => {
          resolve(userLocalStorage);
        });
    });
  }

}
